import React from 'react'

// 手機文章頁刊頭 ad
export default function AmpArticleTopAd({ isR18Article, isLoveSite }) {
  const getAdSlot = () => {
    if (isR18Article) return '/90969475/amp_mobile_18adult_article_top_banner'
    if (isLoveSite) return '/90969475/amp_mobile_love_article_top_banner'
    return '/90969475/amp_mobile_article_top_banner'
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <amp-ad width="336" height="280" type="doubleclick" data-slot={getAdSlot()} />
    </div>
  )
}
